import { Component, OnInit } from '@angular/core';
import { ProfileModuleConsts } from '../../conatants';
import { Title } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router,ActivatedRoute, NavigationEnd } from '@angular/router';
import { ProfileService } from '../../services/profile.service';
import { AuthService } from 'src/app/core/services/auth.service';
import {AuthLoginService} from 'src/app/user/services/auth-login.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss', '../change-password/change-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  fieldTextType: boolean;
  fieldTextType1: boolean;
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  toggleFieldTextType1() {
    this.fieldTextType1 = !this.fieldTextType1;
  }

  ResetForm: FormGroup;
  submitted = false;
  errMessage: any;
  hide: boolean = false;
  commonErrMessage = '';
  constructor(private titleService: Title,
    private router: Router,
    private formBuilder: FormBuilder,
    private profileService: ProfileService,
    private authServiceLogin:AuthLoginService,
    private authService: AuthService,
    private stateService: StatePersistService,
    private route: ActivatedRoute
  ) { 

    const body = document.getElementsByTagName('body')[0];
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(res => {
      if (this.router.url == "/profile/reset-password") {
        body.classList.add('full-page');
      }
      else {
        body.classList.remove('full-page');
      }
    });



  }

  ngOnInit(): void {
    this.stateService.setLocalStorage('address-disabled', true)
    this.titleService.setTitle(ProfileModuleConsts.RESET_PASSWORD_PAGE_TITLE);
    this.ResetForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
      confirmpassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
    });

    this.ResetForm.get('password').valueChanges
      .subscribe(password => {
        const confirm_password = this.ResetForm.controls.confirmpassword.value;
        if (confirm_password === password) {
          this.errMessage = '';
        } else {
          this.errMessage = 'New Password not matched with Confirm password';
        }
      });

    this.ResetForm.get('confirmpassword').valueChanges
      .subscribe(confirmpassword => {
        const password = this.ResetForm.controls.password.value;
        if (password === confirmpassword) {
          this.errMessage = '';
        } else {
          this.errMessage = 'Confirm Password not matched with New password';
        }
      });
  }

  resetPassword() {
    this.submitted = true;
    this.commonErrMessage = ''
    const password = this.ResetForm.controls.password.value;
    const confPassword = this.ResetForm.controls.confirmpassword.value;
    if (password !== confPassword) {
      this.commonErrMessage = 'Confirm Password not matched with New password';
      return;
    }
    if (this.ResetForm.invalid) {
      return;
    }

    const encrypted_password = this.authServiceLogin.createHashedPassword(password);

    this.profileService.resetPassword({ 'password': encrypted_password })
      .subscribe(
        data => {
          const user = this.stateService.getLocalStorage('currentUser')
          user['is_temporary_password'] = false
          this.authService.login(user)
          this.router.navigate(['/home'])
        },
        error => {

        }
      );
  }


}
